{
  "title": "Casino Cashback",
  "yourLevel": "YOUR LEVEL",
  "completed": "COMPLETED",
  "locked": "LOCKED",
  "xpLabel": "Experience",
  "xpRule": "Experience calculation: €1 bet = {{xp}} experience points",
  "cashback": "Cashback {{pct}}%",
  "cashbackMax": "Cashback {{lo}}% - {{hi}}%",
  "daily": "Daily",
  "everyDays": "Once every {{days}} days",
  "active": "Active: AZN {{amount}}",
  "claim": "CLAIM",
  "howTitle": "How does it work?",
  "how1": "Play your favorite slots and games",
  "how2": "Earn XP and raise your level",
  "how3": "Get cashback and rewards",
  "lockedNote": "More XP is required to reach «{{name}}»",
  "loginHint": "Log in for XP, cashback and Claim",
  "login": "Log in",
  "history": "History",
  "historyEmpty": "No records yet.",
  "claimTitle": "Claim cashback",
  "claimAmount": "Amount: {{amount}} AZN",
  "claimNote": "Direct to real balance. Wagering: 0x.",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "congrats": "Congratulations!",
  "newLevel": "New VIP level: {{name}}",
  "continue": "Continue",
  "infoBody": "Only real-money casino bets create XP and cashback. Bonus, sports and demo excluded. 24h wait and min 1 AZN.",
  "close": "Close",
  "maxNote": "VIP MAX — XP stops. Category turnover cashback.",
  "level_1": "Copper",
  "level_2": "Bronze",
  "level_3": "Silver",
  "level_4": "Gold",
  "level_5": "Ruby",
  "level_6": "Sapphire",
  "level_7": "Diamond",
  "level_8": "VIP LEVEL",
  "maintenance": "Maintenance — claiming is temporarily closed.",
  "rulesTitle": "RULES",
  "lockedShort": "LOCKED",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir"
}
